import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "mobile-tabs",
  role: "tablist",
  "aria-label": "Idea Status Tabs"
}
const _hoisted_2 = ["aria-selected", "onClick"]
const _hoisted_3 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("button", {
        key: item.index,
        class: _normalizeClass(["tab-chip", { active: String(item.index) === _ctx.activeIndex }]),
        role: "tab",
        "aria-selected": String(item.index) === _ctx.activeIndex,
        onClick: ($event: any) => (_ctx.$emit('select', String(item.index)))
      }, [
        _createElementVNode("span", {
          class: "status-dot",
          style: _normalizeStyle({ backgroundColor: _ctx.getStatusColor(item.index) })
        }, null, 4),
        _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}